import api from './api';
import { Order } from '../types';

export interface CreateOrderData {
  order_date: string;
  sales_officer_id: number;
  brand_id: number;
  supplier_id?: number;
  customer_id?: number;
  customer_code?: string;
  location_id?: number;
  district?: string;
  destination?: string;
  product_type?: string;
  quantity?: number;
  price_per_bag?: number;
  order_number?: string;
  order_type?: 'EX' | 'FOR';
  payment_status?: string;
  po_status?: string;
  dispatch_status?: string;
  invoice_status?: string;
}

export interface UpdateOrderData {
  order_date?: string;
  sales_officer_id?: number;
  brand_id?: number;
  supplier_id?: number;
  customer_id?: number;
  customer_code?: string;
  district?: string;
  destination?: string;
  product_type?: string;
  quantity?: number;
  price_per_bag?: number;
  order_number?: string;
  order_type?: 'EX' | 'FOR';
  payment_status?: string;
  po_status?: string;
  dispatch_status?: string;
  invoice_status?: string;
}

export interface OrderFilters {
  order_date?: string;
  date_from?: string;
  date_to?: string;
  sales_officer_id?: number;
  brand_id?: number;
  customer_id?: number;
  payment_status?: string;
  po_status?: string;
  dispatch_status?: string;
  invoice_status?: string;
  search?: string;
  limit?: number;
  offset?: number;
}

export interface OrdersListResponse {
  data: Order[];
  count: number;
  total: number;
}

export interface BulkDeleteOrdersResponse {
  total_selected: number;
  deleted_count: number;
  skipped_count: number;
  errors: string[];
}

export const orderService = {
  getAll: async (filters?: OrderFilters): Promise<OrdersListResponse> => {
    const response = await api.get('/api/orders', { params: filters });
    if (Array.isArray(response.data)) {
      return { data: response.data, count: response.data.length, total: response.data.length };
    }
    return response.data;
  },

  getById: async (id: number): Promise<Order> => {
    const response = await api.get(`/api/orders/${id}`);
    return response.data;
  },

  create: async (data: CreateOrderData): Promise<Order> => {
    const response = await api.post('/api/orders', data);
    return response.data;
  },

  update: async (id: number, data: UpdateOrderData): Promise<void> => {
    await api.put(`/api/orders/${id}`, data);
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/orders/${id}`);
  },

  bulkDelete: async (orderIds: number[]): Promise<BulkDeleteOrdersResponse> => {
    const response = await api.post('/api/orders/bulk-delete', { order_ids: orderIds });
    return response.data;
  },
};




